module.exports = __webpack_public_path__ + "static/img/test4.cacb12f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test4.jpg
// module id = 9r7W
// module chunks = 25